import TrainingList from "components/TrainingList";
import { withRouter, Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { css } from "@emotion/css";
import { Button, Space, Typography, message } from "antd";
import { useTranslation } from "react-i18next";
import { changeStateBuildProfile, getApplicationStatus } from "utils/api";
import LanguageDropdown from "components/LanguageDropdown";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { NEW_APPLICATION_STATUS } from "utils/consts";
import useQuery from "utils/hooks/useQuery";

function Training({ location, history }) {
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const query = useQuery();
  const rawRole = location.state?.role || query.get("role");
  const role = Number.parseInt(rawRole, 10);
  const hasValidRole = Number.isInteger(role) && !Number.isNaN(role);
  const email = location.state?.email || query.get("email");
  const [applicationData, setApplicationData] = useState(
    location.state?.applicationData
  );
  var n50_flag = false;
  if (location && location.pathname.includes("n50")) {
    n50_flag = true;
  }
  const [, setFlag] = useState(false);

  const [buttonFlag, setButtonFlag] = useState(false);

  useEffect(() => {
    if (!hasValidRole || !email) {
      history.replace("/");
    }
  }, [email, hasValidRole, history]);

  useEffect(() => {
    async function getApplicationData() {
      const result = await getApplicationStatus(email, role);
      if (!result?.ok) {
        messageApi.error({
          content:
            result?.error ||
            t("apply.errorConnection") ||
            "Could not load your application. Please try again.",
          duration: 0,
          key: "applicationStatus",
          onClick: () => messageApi.destroy("applicationStatus"),
        });
        return;
      }
      setApplicationData(result.application_data);
      if (result.state === "BuildProfile" || result.state === "COMPLETED") {
        setButtonFlag(false);
      }
      setFlag((f) => !f);
    }
    if (hasValidRole && email && !applicationData) {
      getApplicationData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onCompleteTraining = async () => {
    if (!hasValidRole || !email) {
      messageApi.error({
        content: "Could not submit this role's application form",
        duration: 0,
        key: "failed_submit",
        onClick: () => messageApi.destroy("failed_submit"),
      });
      return;
    }

    setLoading(true);
    const res = await changeStateBuildProfile({
      email,
      role,
      preferred_language: i18n.language,
    });
    setLoading(false);
    if (res?.ok && res.state === NEW_APPLICATION_STATUS.BUILDPROFILE) {
      history.push({
        pathname: n50_flag ? "/n50/build-profile" : "/build-profile",
        state: { email, role },
      });
      return;
    }
    messageApi.error({
      content:
        res?.error ||
        t("apply.errorConnection") ||
        "Could not advance to Build Profile. Please try again.",
      duration: 0,
      key: "BuildProfile",
      onClick: () => messageApi.destroy("BuildProfile"),
    });
  };

  const allChecked = (value) => {
    if (
      applicationData?.application_state === "BuildProfile" ||
      applicationData?.application_state === "COMPLETED"
    ) {
      setButtonFlag(false);
    } else {
      setButtonFlag(value);
    }
  };

  if (!hasValidRole || !email) {
    return <>{contextHolder}</>;
  }

  return (
    <div
      className={css`
        width: 100%;
        height: 100%;
        min-height: 100vh;
        overflow: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      `}
    >
      {contextHolder}
      <div
        className={css`
          min-width: 400px;
          width: 70%;
          background: #fff;
          border-radius: 2em;
          padding: 2em;
          margin: 4em 0;
          box-shadow: 0 1px 4px rgba(5, 145, 255, 0.1);

          @media (max-width: 991px) {
            width: 90%;
            margin: 2em 0;
          }

          @media (max-width: 575px) {
            width: 100%;
            margin: 0;
            border-radius: 0;
          }
        `}
      >
        <div
          className={css`
            display: flex;
            justify-content: space-between;
            flex-direction: row;
          `}
        >
          <Link to={"/"} id="back">
            <Space>
              <ArrowLeftOutlined />
              {t("common.back")}
            </Space>
          </Link>
          <LanguageDropdown size="large" />
        </div>
        <Typography.Title level={2}>{t("apply.training")}</Typography.Title>
        <TrainingList
          role={role}
          applicationData={applicationData}
          user_email={email ? email : null}
          allChecked={allChecked}
        />
        <br />
        <Button
          type="primary"
          style={{ width: "100%" }}
          loading={loading}
          onClick={onCompleteTraining}
          disabled={!buttonFlag || loading}
        >
          {t("apply.completeTrainings")}
        </Button>
      </div>
    </div>
  );
}

export default withRouter(Training);
